import React, { createContext, useContext, useState, useEffect } from 'react'
import apiClient from '../utils/apiClient'

const SlotsContext = createContext()

export const useSlots = () => {
  const context = useContext(SlotsContext)
  if (!context) {
    throw new Error('useSlots must be used within a SlotsProvider')
  }
  return context
}

export const SlotsProvider = ({ children }) => {
  const [slotsData, setSlotsData] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchSlots = async () => {
    if (loading || slotsData) return // Don't fetch if already loading or have data
    
    // Don't fetch on login page, acknowledge page, profile page, or if no token
    if (window.location.pathname === '/login' || window.location.pathname === '/acknowledge' || window.location.pathname === '/profile' || !localStorage.getItem('idToken')) {
      return
    }
    
    setLoading(true)
    try {
      const response = await apiClient.get(`/admin/slots`)
      setSlotsData(response.data.slot)
    } catch (error) {
      console.error('Error fetching slots:', error)
    } finally {
      setLoading(false)
    }
  }

  const refreshSlots = async () => {
    setSlotsData(null)
    setLoading(false) // Reset loading to allow fetch
    
    // Force fetch fresh data
    setLoading(true)
    try {
      const response = await apiClient.get(`/admin/slots`)
      setSlotsData(response.data.slot)
    } catch (error) {
      console.error('Error fetching slots:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSlots()
  }, [])

  return (
    <SlotsContext.Provider value={{ slotsData, loading, fetchSlots, refreshSlots }}>
      {children}
    </SlotsContext.Provider>
  )
}